<template>
  <div class="manholeCoverManagementBody">
    <el-col style="margin-bottom: 10px">
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        "
      >
        <el-button type="primary" @click="createQRCodeDialogVisibleFlag = true"
          >新生成二维码</el-button
        >
      </div>
    </el-col>

    <div class="tableContainer">
      <el-table
        v-loading="listLoading"
        :data="dataList"
        border
        fit
        highlight-current-row
      >
        <el-table-column label="序号" type="index" align="center" width="50" />
        <el-table-column
          label="生成时间"
          prop="createTime"
          width="200"
          align="center"
        >
          <template slot-scope="scope">
            {{ formatTimestamp(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="生成数" prop="num" width="200" align="center" />
        <el-table-column label="状态" prop="status" width="100" align="center">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.status === 0 ? 'info' : 'success'"
              class="change-state"
              @click=""
            >
              {{ statusTag[scope.row.status] }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" prop="tpye" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status === 1"
              type="text"
              size="small"
              @click="downloadFile(scope.row)"
              >打包下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!--页码-->
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryForm.current"
        :limit.sync="queryForm.size"
        @pagination="pipenetQueryPage"
      />
    </div>

    <el-dialog
      title="新生成二维码"
      :visible.sync="createQRCodeDialogVisibleFlag"
      width="60%"
      :close-on-click-modal="false"
    >
      <el-form label-width="120px">
        <el-form-item label="数量">
          <el-input
            v-model="createNumber"
            placeholder="请输入生成二维码数量"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="creadQRCodeSubmit()">确 定</el-button>
        <el-button type="primary" @click="creadQRCodeCancel()">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss">
.manholeCoverManagementBody {
  width: auto;
  height: 100%;
  padding: 24px;
  overflow: hidden;
  overflow-y: auto;
}
</style>

<script>
import {
  downloadWellQrcode,
  generateWellQrcode,
  pipenetQueryPage,
} from '@/api/pipenetmanagement';
import Pagination from '@/components/PaginationStyle1.vue';

export default {
  components: { Pagination },
  data() {
    return {
      listLoading: false,
      dataList: [],
      total: 0,
      queryForm: {
        size: 10,
        current: 1,
      },
      statusTag: ['生成中', '已生成'],

      createQRCodeDialogVisibleFlag: false,
      createNumber: '',
    };
  },
  methods: {
    async pipenetQueryPage() {
      this.listLoading = true;
      const res = await pipenetQueryPage(this.queryForm);
      // console.log(res)
      const list = res.data.data.records;
      this.dataList = [...list];
      this.total = res.data.data.total;
      this.listLoading = false;
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    async downloadFile(obj) {
      let req = { id: obj.id };

      try {
        const result = await downloadWellQrcode(req);
        // 从响应中获取 Blob 对象
        const blob = result.data;

        // 创建一个 URL 对象
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', '智能井盖二维码.zip'); // 设置下载文件名
        document.body.appendChild(link);
        link.click();

        // 释放 URL 对象
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Download error:', error);
      }
    },
    async creadQRCodeSubmit() {
      if (this.createNumber === '') {
        this.$message.error('请输入生成数量');
        return;
      }

      let req = {
        num: this.createNumber,
      };
      const result = await generateWellQrcode(req);
      if (result.data.code === 200) {
        this.$message({ message: '提交成功', type: 'success' });

        this.createQRCodeDialogVisibleFlag = false;
        this.createNumber = '';
        //添加后刷新
        this.pipenetQueryPage();
      } else {
        this.$message.error(result.data.message);
      }
    },
    creadQRCodeCancel() {
      this.createQRCodeDialogVisibleFlag = false;
      this.createNumber = '';
    },
  },
  created() {
    this.pipenetQueryPage();
  },
};
</script>
